import { useCallback, useEffect, useMemo, useState } from 'react';

import { IRuntimeApiConfig } from '../../services/rt-config/IRuntimeConfigService';
import RuntimeConfigService from '../../services/rt-config/RuntimeConfigService';

const useRuntimeConfig = (
  onError: (e: Error) => void
): IRuntimeApiConfig | null => {
  const runtimeConfigService = useMemo(() => new RuntimeConfigService(), []);
  const [config, setConfig] = useState<IRuntimeApiConfig | null>(null);

  const getConfig = useCallback(async () => {
    try {
      const rtConfig = await runtimeConfigService.getRuntimeApiConfig();
      setConfig(rtConfig);
    } catch (e) {
      if (e instanceof Error) {
        onError(e);
      }
    }
  }, [onError, runtimeConfigService]);

  useEffect(() => {
    void getConfig();
  }, [getConfig]);

  return config;
};

export default useRuntimeConfig;
